import { cn } from "@/utils/theme";
import { Badge, Icon } from "@elaniintc/goes-design-system";

export default function EditableCorrection({
  isLockedApproved,
  hasPreviousCorrectionApproved,
  correction,
  onApprove,
  onDeny,
  onOpenModal,
}: Readonly<{
  isLockedApproved: boolean;
  hasPreviousCorrectionApproved: boolean;
  correction?: { status: "DENIED" | "APPROVED" };
  onApprove: () => void;
  onDeny: () => void;
  onOpenModal: () => void;
}>) {
  if (hasPreviousCorrectionApproved) {
    return (
      <Badge
        shape="square"
        size="sm"
        className="size-6 flex items-center justify-center rounded-lg cursor-pointer"
        variant="success"
        onClick={onApprove}
      >
        <Icon name="check" type="fas" className="text-xs text-success-quiet" />
      </Badge>
    );
  }

  if (isLockedApproved) return null;

  const isDenied = correction?.status === "DENIED";

  return (
    <div className="relative flex w-full items-center content-center gap-3">
      {isDenied && (
        <Badge
          size="xs"
          variant="danger"
          fill="solid"
          className="rounded-full size-5 flex items-center justify-center absolute -top-3 -right-2"
          onClick={onOpenModal}
        >
          <Icon name="comment" type="fas" className="text-2xs text-on-solid" />
        </Badge>
      )}
      <Badge
        shape="square"
        size="sm"
        variant={correction?.status === "APPROVED" ? "success" : "neutral"}
        onClick={onApprove}
        className="size-6 flex items-center justify-center rounded-lg cursor-pointer"
      >
        <Icon
          name="check"
          type="fas"
          className={cn(
            "text-xs",
            correction?.status === "APPROVED" && "text-success-quiet",
          )}
        />
      </Badge>
      <Badge
        shape="square"
        size="sm"
        variant={isDenied ? "danger" : "neutral"}
        onClick={onDeny}
        className="size-6 flex items-center justify-center rounded-lg cursor-pointer"
      >
        <Icon
          name="times"
          type="fas"
          className={cn("text-xs", isDenied && "text-danger-quiet")}
        />
      </Badge>
    </div>
  );
}
